import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=e9564d68&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=e9564d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.nlark.com+vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9564d68",
  null
  
)

export default component.exports